module.exports = __webpack_public_path__ + "img/mobile-preview-bg.14d357a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile-preview-bg.jpg
// module id = Ur56
// module chunks = 38 43